export enum ResidentReligions {
  ChristianCatholic = "Christian Catholic",
  ChristianAnglican = "Christian Anglican",
  ChristianOther = "Christian Other",
  Orthodox = "Orthodox",
  Muslim = "Muslim",
  Hindu = "Hindu",
  Buddhist = "Buddhist",
  Jewish = "Jewish",
  Other = "Other",
  NonReligious = "Non religious"
}